const extractSignature = require('./extractSignature');
const extractLocation = require('./extractLocation');
const extractEventAction = require('./extractEventAction');
const extractName = require('./extractName');
const extractNameExclusive = require('./extractNameExclusive');
const locationOrParty = require('./locationOrParty');
const {
    formatDateTime
} = require('gui');

module.exports = function extractEvents(leg) {
    const loadEvent = {
        time: formatDateTime(leg.Atd || leg.Etd, 'LT'),
        date: formatDateTime(leg.Atd || leg.Etd, 'L'),
        ticks: leg.Atd || leg.Etd,
        isActual: (leg.Atd !== undefined),
        signature: extractSignature(leg.LoadedSignature),
        signatureName: extractName(leg.LoadedSignature),
        signatureNameExclusive: extractNameExclusive(leg.LoadedSignature),
        location: extractLocation(leg.LoadedLocation),
        name: leg.Origin,
        place: locationOrParty(leg.LoadedLocation, leg.Origin),
    };
    loadEvent.placeAction = extractEventAction('load', loadEvent.isActual);
    const unloadEvent = {
        time: formatDateTime(leg.Ata || leg.Eta, 'LT'),
        date: formatDateTime(leg.Ata || leg.Eta, 'L'),
        ticks: leg.Ata || leg.Eta,
        isActual: (leg.Ata !== undefined),
        signature: extractSignature(leg.UnloadedSignature),
        signatureName: extractName(leg.UnloadedSignature),
        signatureNameExclusive: extractNameExclusive(leg.UnloadedSignature),
        location: extractLocation(leg.UnloadedLocation),
        name: leg.Destination,
        place: locationOrParty(leg.UnloadedLocation, leg.Destination),
    };
    unloadEvent.placeAction = extractEventAction('unload', unloadEvent.isActual);

    return [loadEvent, unloadEvent];
}
